export * from "./polyfills";
import { initPolyfills } from "./initPolyfills";
import * as Polyfills from "./polyfills";
import "promise-polyfill/src/polyfill";
initPolyfills(Polyfills);
//# sourceMappingURL=index.js.map